var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTableMergeCells(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3C2.45 3 2 3.45 2 4V20C2 20.55 2.45 21 3 21H21C21.55 21 22 20.55 22 20V4C22 3.45 21.55 3 21 3ZM16.29 8.29L12.58 12L16.29 15.71L17.7 14.3L16.41 13.01H20V19.01H13V17H11V19.01H4V13.01H7.59L6.3 14.3L7.71 15.71L11.42 12L7.71 8.29L6.3 9.7L7.59 10.99H4V4.99H11V7H13V4.99H20V10.99H16.41L17.7 9.7L16.29 8.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableMergeCells);
export default __webpack_public_path__ + "static/media/icon-table-merge-cells.364b3f9d7a7ce28747f0050c0c021294.svg";
export { ForwardRef as ReactComponent };